import loadable from '@loadable/component'

export const HtmlEmbed = loadable(() => import('./HtmlEmbed'))
export type { HtmlEmbedProps } from './HtmlEmbed'
